//@ts-ignore
import React, { useEffect, useState } from "react";
import "./PageError.css";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonRow,
  IonText,
} from "@ionic/react";
import { useHistory, useLocation } from "react-router";
import { alert, alertOutline } from "ionicons/icons";
import { useSession } from "../../hooks/SessionContext";
import useTituloPagina from "../../hooks/tituloPagina";

interface ContainerProps {
  motivo?: string;
}

//@ts-ignore
const PageError: React.FC<ContainerProps> = ({ motivo }) => {
  const location = useLocation();
  const [motivoError, setMotivoError] = useState<string>("");
  const history = useHistory();
  const { hcUL, cargandoSession, setTurnoSeleccionado } = useSession();
  useTituloPagina();

  useEffect(() => {
    if (cargandoSession === false) {
      try {
        //@ts-ignore
        setMotivoError(location.state?.motivo || "");
        if (hcUL === null || hcUL.codigo === 0) {
          setMotivoError("sesion perdida");
        } else setMotivoError("404");
      } catch (e) {
        //@ts-ignore
        console.log("Error: " + e.message);
      }
      setTurnoSeleccionado(null);
      document.title = "Ha ocurrido un error: " + motivo;
    }
  }, [hcUL, cargandoSession]);

  const handleClickRedirigir = (destino: string) => {
    switch (destino) {
      case "MainPage":
        history.push("/portal/Agenda");
        break;
      case "CerrarSesion":
        history.push("/");
        break;
      default:
        break;
    }
  };

  return (
    <IonGrid>
      <IonRow className="LoginViewRow justify-content-center">
        <IonCol>
          <IonCard>
            <IonCardHeader>
              <IonRow className="justify-content-center">
                <IonCardTitle>
                  <h1>Se ha producido un error</h1>
                </IonCardTitle>
              </IonRow>
            </IonCardHeader>
            <IonCardContent>
              <IonItem>
                <IonIcon slot="start" size="large" color="danger" ios={alertOutline} md={alert} />
                <IonText color="danger">
                  {motivoError === "sesion perdida" ? (
                    <>
                      <h2>
                        {"Tu sesión ha expirado "}
                        <a href="/">presiona aquí para redireccionarte al inicio de sesión</a>
                      </h2>
                    </>
                  ) : motivoError === "404" ? (
                    <h2>
                      {"Ruta no encontrada "}
                      <a href="/portal/Agenda">presiona aquí para redireccionarte al inicio</a>
                    </h2>
                  ) : (
                    <h2>
                      {"Ha ocurrido un error "}
                      <a href="/portal/Agenda">presiona aquí para redireccionarte al inicio</a>
                    </h2>
                  )}
                </IonText>
                <IonIcon slot="end" size="large" color="danger" ios={alertOutline} md={alert} />
              </IonItem>
            </IonCardContent>
          </IonCard>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default PageError;
